module.exports = __webpack_public_path__ + "img/6.e014c8ea.png";